import { FORM_STRUCT_PREFIX, FORM_STRUCT_SUFFIX } from 'basic/config'

export const getFormStructUrl = apiMethod =>
  `${process.env.PUBLIC_URL}/${FORM_STRUCT_PREFIX}${apiMethod}${FORM_STRUCT_SUFFIX}?v=${process.env.REACT_APP_VERSION}`
